// Constants.vue
<script>
const { ObjectId } = require("bson");

export default {
  ID_SENSOR_TYPES : {
  TEMPI2C: ObjectId("613756b0acdbeee770612ecb"),
  TEMPSHT20: ObjectId("613756b0acdbeee770612ecc"),
  FLOWREED: ObjectId("613756b0acdbeee770612ecd"),
  TEMPANALOG: ObjectId("613756b0acdbeee770612ece"),
  TENSIONADC: ObjectId("613756b0acdbeee770612ecf"),
  GALGA: ObjectId("613756b0acdbeee770612ed0"),
  METEO: ObjectId("613756b0acdbeee770612ed1"),
  LED: ObjectId("613756b0acdbeee770612ed2"),
  CARDETECTOR: ObjectId("613756b0acdbeee770612ed3"),
  VISIBILIDAD: ObjectId("613756b0acdbeee770612ed4"),
  VELOCIDAD: ObjectId("613756b0acdbeee770612ed5"),
  BMA400: ObjectId("613756b0acdbeee770612ed6"),
  ADXL355: ObjectId("613756b0acdbeee770612ed7"),
  LUMINOSIDAD: ObjectId("613756b0acdbeee770612ed8"),
  GPS: ObjectId("613756b0acdbeee770612ed9"),
  TEMP4NALOG: ObjectId("613756b0acdbeee770612eda"),
  FLOWHIDROJET: ObjectId("613756b0acdbeee770612edb"),
  PIEZOMETRO: ObjectId("613756b0acdbeee770612edc"),
  COBERTURA: ObjectId("613756b0acdbeee770612edd"),
  CT_HOBUT: ObjectId("613756b0acdbeee770612edf"),
  PLUVIOMETRO_WS2080: ObjectId("613756b0acdbeee770612eff"),
  ADCTEMP: ObjectId("613756b0acdbeee770612f00"),
  FLOWGIE: ObjectId("613756b0acdbeee770612f01"),
  WATERQUALITY: ObjectId("613756b0acdbeee770612f02"),
  FLOWMETER: ObjectId("613756b0acdbeee770612f04"),
  ALARMSENSOR: ObjectId("613756b0acdbeee770612f05"),
  PRESSURESENSOR: ObjectId("613756b0acdbeee770612f06"),
  VALVESENSOR: ObjectId("613756b0acdbeee770612f07"),
  PRESSUREVEGABARSENSOR: ObjectId("647dac2c8f11c4f01519fbd9"),
  TEMPCALEXTEMPSENSOR: ObjectId("647dac2c8f11c4f01519fbc0"),
  T3110EXSENSOR : ObjectId("647dac2c8f11c4f01519fbc1"),
  ROCIOSENSOR : ObjectId("647dac2c8f11c4f01519fbc2"),
  CTHOBUT3 : ObjectId( "647dac2c8f11c4f01519fbc3"),
  S451_CAUDALIMETRO:  ObjectId( "647dac2c8f11c4f01519fbc4"),
  SEN0604: ObjectId("647dac2c8f11c4f01519fbc5"),
  SEN0605: ObjectId("647dac2c8f11c4f01519fbc6")
}

}
</script>